<template>
  <div>
    <div class="nav-menu" :class="[isDropdownActive ? 'nav-menu-active' : '']">
      <div class="nav-menu-header">
        <p class="overline fw-500 text-muted mb-0">Tools</p>
        <button class="btn btn-link ripple ripple-primary m-0" @click="toggleDropdown()">
          <i class="material-icons-outlined">&#xe5cd;</i>
        </button>
      </div>
      <div class="nav-menu-body">
        <router-link to="/color" class="nav-menu-item">
          <i class="material-icons-outlined icon-wrap">&#xe891;</i>
          <p class="mb-0">Color shades & tints</p>
        </router-link>
        <router-link to="/color-image-picker" class="nav-menu-item">
          <i class="material-icons-outlined icon-wrap">&#xe3b8;</i>
          <p class="mb-0">Image color palette</p>
        </router-link>
        <router-link to="/gradient/generator" class="nav-menu-item">
          <i class="material-icons-outlined icon-wrap">&#xe23a;</i>
          <p class="mb-0">Gradient generator</p>
        </router-link>
        <a href="https://mixgradients.dev/?ref=colorffy" target="_blank" rel="noopener" class="nav-menu-item">
          <i class="material-icons-outlined icon-wrap">&#xefe3;</i>
          <p class="mb-0">Mix Gradients</p>
          <i class="material-icons-outlined mdc-18 ms-2 me-0">&#xe895;</i>
        </a>
        <div class="nav-menu-item">
          <i class="material-icons-outlined icon-wrap text-muted">&#xe40a;</i>
          <p class="text-muted mb-0">Palette generator</p>
        </div>
        <router-link to="/random-color" class="nav-menu-item">
          <i class="material-icons-outlined icon-wrap">&#xeb40;</i>
          <p class="mb-0">Random color</p>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'isDropdownActive',
    'toggleDropdown'
  ]
}
</script>